import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const resolveImageUrl = (u) => {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  return `${BACKEND_URL}${u}`;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tv_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const trackClick = async (link) => {
  try {
    await api.post('/track', {
      link_id: link.id,
      label: link.label,
      url: link.url,
      referrer: document.referrer || '',
      user_agent: navigator.userAgent,
    });
  } catch (e) {
    // silently ignore
  }
};
